<template>
  <div class="mb-8 mt-4">
    <div class="-mb-4 flex w-full">
      <img
        class="mr-3 lg:hidden"
        src="@/assets/svg/transactions/filters.svg"
        alt="filters"
        @click="() => (showDrawer = true)"
      />
      <div class="mr-6 grow">
        <GeneralInput
          v-model:data="search"
          noMargin
          type="text"
          name="search"
          :label="$t('contracts.search')"
        >
        </GeneralInput>
      </div>
      <div
        class="mb-4 hidden cursor-pointer items-center rounded-2xl bg-white px-8 py-0 lg:flex"
        @click="showFiltersPopup"
      >
        <img src="@/assets/svg/transactions/filters_desktop.svg" alt="cross" class="mr-2 w-4" />
        <p class="text-sm font-semibold text-grey-2/80">
          {{ $t('transactions.filters.title') }}
        </p>
      </div>
    </div>
    <Drawer v-if="showDrawer" minHeight="h-5/6" @close="close">
      <template v-slot:content>
        <ContractFiltersDrawer :search="search" @filter="close" />
      </template>
    </Drawer>
  </div>
</template>

<script>
import Drawer from '@/components/general/Drawer.vue'
import GeneralInput from '@/components/general/Input.vue'
import ContractFiltersDrawer from '@/components/contracts/ContractFiltersDrawer.vue'
import { ref } from 'vue'
import { useStore } from 'vuex'
import { watch } from 'vue'
export default {
  components: {
    Drawer,
    ContractFiltersDrawer,
    GeneralInput,
  },
  emits: ['filter'],
  setup(props, { emit }) {
    const showDrawer = ref(false)
    const store = useStore()
    const search = ref(null)

    const close = () => {
      showDrawer.value = false
      emit('filter')
    }

    const showFiltersPopup = () => {
      const popup = {
        side: true,
        component: 'ContractFiltersDrawer',
      }
      store.dispatch('setPopup', popup)
    }

    watch(
      () => search.value,
      async () => {
        store.dispatch('setSearch', search.value)
      }
    )

    return {
      showDrawer,
      close,
      search,
      showFiltersPopup,
    }
  },
}
</script>

<style lang="scss" scoped></style>
